import React, { useEffect, useState } from 'react';
import auth0 from 'auth0-js';
export default function FederatedLogin({ auth0Config, connection, destination }) {
  const [webAuth] = useState(
    new auth0.WebAuth({
      domain: auth0Config.domain,
      clientID: auth0Config.clientId,
      redirectUri: 'https://iam.cj.com/api/sso/oauth-callback',
      audience: auth0Config.audience,
    })
  );
  useEffect(() => {
    const nonce = generateNonce();
    const state = {
      redirectPath: destination,
      nonce: nonce,
    };
    webAuth.authorize({
      connection: connection,
      responseType: 'id_token', // Request Auth0 id token (or 'token id_token' for access_token too)
      responseMode: 'form_post',       // Secure: tokens POSTed to backend (not in URL)
      // Pass state data including nonce for replay attack protection
      nonce: nonce,
      state: btoa(JSON.stringify(state))
    });
  }, [webAuth, connection, destination])   
  return <></>
}

export function generateNonce(length = 32) {
  const randomBytes = new Uint8Array(length);
  crypto.getRandomValues(randomBytes);
  
  // Convert to base64url (URL-safe base64 without padding)
  return btoa(String.fromCharCode(...randomBytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}
